"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_utils_1 = require("mobx-utils");
var mobx_1 = require("mobx");
var blockConfigUtil_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/blockConfigUtil");
var BlockStyleEventService_1 = __importStar(require("../BlockStyleEventService/BlockStyleEventService"));
var CompileAdvancedStyle_1 = __importDefault(require("./CompileAdvancedStyle"));
var CompileBlockStyle_1 = __importDefault(require("./CompileBlockStyle"));
var InlineBlockStyle = (function (_super) {
    __extends(InlineBlockStyle, _super);
    function InlineBlockStyle() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.registerBlockStyleChangeEvents = function () {
            var eventEmitter = BlockStyleEventService_1.default.createNewEventEmittersWithBlockId(_this.props.blockStore.$id);
            eventEmitter.on(BlockStyleEventService_1.BLOCK_STYLE_CHANGE, function (newStyle) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.props.blockStore.blockStyleStore.updateStyle((0, blockConfigUtil_1.addHash)(newStyle));
                    return [2];
                });
            }); });
        };
        return _this;
    }
    InlineBlockStyle.prototype.componentDidMount = function () {
        this.registerBlockStyleChangeEvents();
    };
    InlineBlockStyle.prototype.componentWillUnmount = function () {
        BlockStyleEventService_1.default.removeEventEmitterByBlockId(this.props.blockStore.$id);
    };
    Object.defineProperty(InlineBlockStyle.prototype, "compiledBlockStyle", {
        get: function () {
            return this.observableCompiledBlockStyle.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InlineBlockStyle.prototype, "compileAdvancedStyle", {
        get: function () {
            return this.observableCompileAdvancedStyle.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InlineBlockStyle.prototype, "observableCompiledBlockStyle", {
        get: function () {
            var _this = this;
            var _a = this.props, blockStore = _a.blockStore, brandStore = _a.brandStore;
            return (0, mobx_utils_1.fromPromise)((function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, (0, CompileBlockStyle_1.default)(blockStore.proxyBlockModel, brandStore.allColors)];
                        case 1: return [2, _a.sent()];
                    }
                });
            }); })());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InlineBlockStyle.prototype, "observableCompileAdvancedStyle", {
        get: function () {
            var _this = this;
            var blockStore = this.props.blockStore;
            return (0, mobx_utils_1.fromPromise)((function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, (0, CompileAdvancedStyle_1.default)(blockStore.proxyBlockModel, blockStore.blockStyleStore.model.css)];
                        case 1: return [2, _a.sent()];
                    }
                });
            }); })());
        },
        enumerable: false,
        configurable: true
    });
    InlineBlockStyle.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "inline-css__custom" },
                react_1.default.createElement("style", { dangerouslySetInnerHTML: {
                        __html: this.compileAdvancedStyle,
                    } })),
            react_1.default.createElement("div", { className: "inline-css__block-style" },
                react_1.default.createElement("style", { dangerouslySetInnerHTML: {
                        __html: this.compiledBlockStyle,
                    } }))));
    };
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], InlineBlockStyle.prototype, "compiledBlockStyle", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], InlineBlockStyle.prototype, "compileAdvancedStyle", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], InlineBlockStyle.prototype, "observableCompiledBlockStyle", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], InlineBlockStyle.prototype, "observableCompileAdvancedStyle", null);
    InlineBlockStyle = __decorate([
        mobx_react_1.observer
    ], InlineBlockStyle);
    return InlineBlockStyle;
}(react_1.default.Component));
exports.default = InlineBlockStyle;
